module.exports = __webpack_public_path__ + "img/public-sector.f3fdba9a.png";